export default __webpack_public_path__ + "static/media/Donna_Griffit_AHV_In_Moms_We_Trust.6621f105.jpg";